import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '@/auth/authContext';
import { getUnreadNotificationCount } from '@/services/notificationService';
import { subscribeChatSocket } from '@/services/chatSocket';
import { onBadgesChanged } from '@/services/badgeSignal';

/** The socket is the fast path; the poll is what keeps the badge right without it. */
export const NOTIFICATION_POLL_MS = 60_000;

export function useUnreadNotifications(): number {
  const { status } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(() => {
    if (status !== 'authed') {
      setCount(0);
      return;
    }
    getUnreadNotificationCount()
      .then(setCount)
      .catch(() => {
        /* a badge is not worth surfacing an error for */
      });
  }, [status]);

  useEffect(() => {
    refresh();
    if (status !== 'authed') return;

    const timer = window.setInterval(refresh, NOTIFICATION_POLL_MS);
    const onFocus = () => refresh();
    window.addEventListener('focus', onFocus);
    const unsubscribe = subscribeChatSocket({
      onNotification: ({ unreadCount }) => setCount(unreadCount),
    });
    // Any read or withdrawn row — from this screen, a chat, Bildir, or another device.
    const offBadges = onBadgesChanged(refresh);

    return () => {
      window.clearInterval(timer);
      window.removeEventListener('focus', onFocus);
      unsubscribe();
      offBadges();
    };
  }, [status, refresh]);

  return count;
}
